<template>
  <div class="full-height contracts">
    <Row>
      <i-col :md="12" :xs="14">
        <p class="boldtext">{{ $t("Account") }}</p>
      </i-col>
      <i-col v-if="isOperatorOrAbove()" :md="12" :xs="10" align="right">
        <button class="action-button" @click="triggerShowCreateModal">
          <Icon type="md-add" size="18" />
          {{ $t("Add contract") }}
        </button>
        <ContractModalForm
          v-model="modalData"
          :modalOnSubmit="modalOnSubmit"
          @hide="triggerHideModal"
        />
      </i-col>
    </Row>
    <transition appear name="slide-left-centered">
      <Table
        :columns="columns"
        :data="contracts.results"
        style="height: calc(700px)"
        class="s2ec-table accounts"
        @on-row-click="open"
        :loading="isLoading"
      >
        <div slot="header" class="s2ec-table-header accounts">
          <Row>
            <i-col :md="15" :xs="15">
              <router-link :to="{ name: 'accounts' }">
                <Icon type="ios-folder-open" size="27" class="icon" />
              </router-link>
              <Icon type="ios-arrow-forward" size="27" class="arrow" />
              {{ client.client_name }}
              <span
                class="circle"
                :class="[client.client_is_active ? 'green' : 'red']"
              ></span>
            </i-col>
          </Row>
          <Row class="md-4" type="flex">
            <i-col :md="3" :xs="5" class="ml-4">
              <Icon type="logo-codepen" class="smallicon" size="20" />
              <p class="text">
                {{ $t(client.client_type) }}
              </p>
            </i-col>
            <i-col :md="3" :xs="5">
              <Icon type="md-contact" size="20" class="smallicon" />
              <p class="text">
                {{ client.client_name }}
                <br />
                {{ client.client_phone }}
              </p>
            </i-col>
            <i-col :md="3" :xs="5" align="left">
              <Icon type="md-locate" size="20" class="smallicon" />
              <p class="text">
                {{ client.client_billing_address }}<br />
                {{ client.client_billing_city }}
              </p>
            </i-col>
          </Row>
        </div>
      </Table>
    </transition>
  </div>
</template>

<script>
import ContractModalForm from "@/views/accounts/modals/ContractModalForm";
import { getContractsQry, getClientQry } from "@/services/accounts.service";
import {
  postClientContractQry,
  deleteClientContractQry,
  patchContractQry,
  postDomainOrEmailQry,
  putClientContractQry,
  deleteDomainOrEmailQry,
} from "@/services/contract.service";
import AppModal from "@/components/common/AppModal";
import moment from "moment";
import DateFormat from "@/mixins/dateFormat";

export default {
  name: "ClientContract",
  components: {
    ContractModalForm,
    getContractsQry,
    deleteClientContractQry,
    AppModal,
    patchContractQry,
  },
  mixins: [DateFormat],
  data() {
    return {
      isLoading: false,
      client: {
        client_name: "",
      },
      contracts: {
        count: 0,
        results: [],
      },
      modalData: {
        showModal: false,
        form: {},
      },
      modalOnSubmit: null,
      columns: [
        {
          title: this.$t("Contract name"),
          key: "contract_name",
        },
        {
          title: this.$t("Contract number"),
          key: "contract_identifier",
        },
        {
          title: this.$t("State"),
          sortable: true,
          align: "center",
          render: (h, params) => {
            if (params.row.contract_is_active === false) {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#A5A5A5",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("Suspended")
                ),
              ]);
            } else if (
              moment(moment().format()).isAfter(
                moment(params.row.contract_start_date)
              ) &&
              moment(moment().format()).isBefore(
                moment(params.row.contract_end_date)
              )
            ) {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "rgb(84, 173, 119)",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("In progress")
                ),
              ]);
            } else if (
              moment(moment().format()).isBefore(
                moment(params.row.contract_start_date)
              )
            ) {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#EE823A",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("Incoming")
                ),
              ]);
            } else {
              return h("div", {}, [
                h(
                  "p",
                  {
                    style: {
                      backgroundColor: "#D54848",
                      padding: "10px",
                      border: "none",
                      width: "89px",
                      margin: "auto",
                      height: "40px",
                      color: "white",
                      borderRadius: "5px",
                    },
                  },
                  this.$t("Completed")
                ),
              ]);
            }
          },
        },
        {
          title: this.$t("Opening date"),
          key: "contract_start_date",
          sortable: true,
          render: (h, params) => {
            return h("div", [
              h("p", this.dateFormat(params.row.contract_start_date)),
            ]);
          },
        },
        {
          title: this.$t("Expiration date"),
          key: "contract_end_date",
          sortable: true,
          render: (h, params) => {
            if (
              moment(moment().format()).isAfter(
                moment(params.row.contract_end_date)
              )
            ) {
              return h("div", [
                h(
                  "p",
                  {
                    style: {
                      color: "red",
                    },
                  },
                  this.dateFormat(params.row.contract_end_date)
                ),
              ]);
            } else {
              return h("div", [
                h("p", this.dateFormat(params.row.contract_end_date)),
              ]);
            }
          },
        },
        {
          title: this.$t("Access"),
          key: "contract_user_limit",
          sortable: true,
          render: (h, params) => {
            if (params.row.contract_user_limit === 999999) {
              return h("div", [h("p", this.$t("Unlimited"))]);
            } else {
              return h("div", [h("p", params.row.contract_user_limit)]);
            }
          },
        },
        {
          title: this.$t("Actions"),
          key: "actions",
          align: "right",
          render: (h, params) => {
            if (this.isOperatorOrAbove()) {
              return [
                h("Button", {
                  props: {
                    icon: "md-create",
                  },
                  attrs: {
                    title: this.$t("Edit"),
                  },
                  class: "table-button",
                  on: {
                    click: (evt) => {
                      evt.stopPropagation(); // "click.stop" is not supported here
                      this.triggerShowUpdateModal(params.row);
                    },
                  },
                }),
                h("Button", {
                  props: {
                    icon: params.row.contract_is_active
                      ? "md-close"
                      : "md-done-all",
                  },
                  attrs: {
                    title: params.row.contract_is_active
                      ? this.$t("Disable")
                      : this.$t("Enable"),
                  },
                  class: "table-button",
                  on: {
                    click: (evt) => {
                      evt.stopPropagation(); // "click.stop" is not supported here
                      this.changeStateContract(
                        params.row.client,
                        params.row.id,
                        params.row.contract_is_active
                      );
                    },
                  },
                }),
                h("Button", {
                  props: {
                    icon: "md-trash",
                  },
                  attrs: {
                    title: this.$t("Delete"),
                  },
                  class: "table-button",
                  on: {
                    click: (evt) => {
                      evt.stopPropagation(); // "click.stop" is not supported here
                      this.removeContract(
                        params.row.id,
                        params.index,
                        params.row.client
                      );
                    },
                  },
                }),
              ];
            } else {
              return [];
            }
          },
        },
      ],
    };
  },
  computed: {
    emptyContractForm() {
      return {
        contract_start_date: "",
        contract_end_date: "",
        contract_user_limit: "",
        contract_is_active: true,
        domains_or_emails: null,
      };
    },
  },
  created() {
    this.modalData.form = { ...this.emptyContractForm };
    this.modalOnSubmit = this.triggerCreateContract;

    this.fetchClient();
    this.fetchContracts();
  },
  methods: {
    fetchClient() {
      this.isLoading = true;
      getClientQry(this.$route.params.id)
        .then((res) => {
          this.client = res.data;
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred retrieving client"),
            duration: 5,
          });
        });
    },
    fetchContracts() {
      getContractsQry(this.$route.params.id)
        .then((res) => {
          this.contracts.results = res.data.results;
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred retrieving contracts"),
            duration: 5,
          });
        })
        .finally(() => {
          this.isLoading = false;
        })
    },
    open(row) {
      this.$router.push({
        name: "users",
        params: {
          contractId: row.id,
          id: row.client,
        },
      });
    },
    removeContract(id, idx, idClient) {
      this.$AppModal.AppConfirm({
        extraTitle: this.$t("Delete"),
        message: this.$t(
          "You are about to delete this item. Are you sure to continue"
        ),
        loading: true,
        cancelText: this.$t("Cancel"),
        onConfirm: () => {
          deleteClientContractQry(idClient, id)
            .then(() => {
              this.contracts.count -= 1;
              this.contracts.results.splice(idx, 1);
              this.$AppModal.remove();
              this.$Message.success(this.$t("Successfully deleted contract"));
            })
            .catch(() => {
              this.$AppModal.remove();
              this.$Message.error({
                content: this.$t("Error occurred deleting contract"),
                duration: 5,
              });
            });
        },
      });
    },
    changeStateContract(client_id, contract_id, state) {
      patchContractQry(client_id, contract_id, { contract_is_active: !state })
        .then(() => {
          this.$Message.success(this.$t("Successfully updated a contract"));
          setTimeout(() => {
            window.location.reload();
          }, 500);
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error occurred"),
            duration: 5,
          });
        });
    },
    triggerShowCreateModal() {
      this.modalData.form = {
        ...this.emptyContractForm,
        domains_or_emails: [],
      };
      this.modalData.showModal = true;
      this.modalOnSubmit = this.triggerCreateContract;
    },
    triggerShowUpdateModal(contractData) {
      this.modalData.form = {
        ...contractData,
        domains_or_emails: contractData.contract_access_restrictions.map(
          (e) => e.domain_or_email
        ),
      };
      this.modalData.showModal = true;
      this.modalOnSubmit = this.triggerUpdateContract;
    },
    triggerHideModal() {
      this.modalData.form = {
        ...this.emptyContractForm,
        domains_or_emails: [],
      };
      this.modalData.showModal = false;
      this.modalOnSubmit = this.triggerCreateContract;
    },
    triggerCreateContract() {
      const clientId = this.$route.params.id;
      const contractData = this.modalData.form;

      postClientContractQry(clientId, contractData)
        .then((res) => {
          this.createDomainsOrEmails(
            res.data.id,
            this.modalData.form.domains_or_emails
          );
          this.$Message.success(this.$t("Successfully created a contract"));
          this.fetchContracts();
          this.triggerHideModal();
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error when adding a contract"),
            duration: 5,
          });
        });
    },
    triggerUpdateContract() {
      const clientId = this.$route.params.id;
      const contractId = this.modalData.form.id;
      const contractData = this.modalData.form;

      putClientContractQry(clientId, contractId, contractData)
        .then(() => {
          this.updateDomainsOrEmails(contractId);
          this.$Message.success(this.$t("Successfully updated a contract"));
          this.fetchContracts();
          this.triggerHideModal();
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t("Error when updating a contract"),
            duration: 5,
          });
        });
    },
    updateDomainsOrEmails(contract_id) {
      const contractAccessRestrictions =
        this.modalData.form.contract_access_restrictions;
      const domainsOrEmails = this.modalData.form.domains_or_emails;

      const newDomainsOrEmails = domainsOrEmails.filter((domain_or_email) => {
        return !contractAccessRestrictions
          .map((e) => e.domain_or_email)
          .includes(domain_or_email);
      });

      const removedDomainsOrEmails = contractAccessRestrictions.filter(
        (contractAccessRestriction) => {
          return !domainsOrEmails.includes(
            contractAccessRestriction.domain_or_email
          );
        }
      );

      this.createDomainsOrEmails(contract_id, newDomainsOrEmails);
      this.deleteContractAccessRestrictions(
        contract_id,
        removedDomainsOrEmails
      );
    },
    createDomainsOrEmails(contract_id, domains_or_emails) {
      const clientId = this.$route.params.id;

      domains_or_emails.forEach((domain_or_email) => {
        postDomainOrEmailQry(clientId, contract_id, {
          domain_or_email: domain_or_email,
        });
      });
    },
    deleteContractAccessRestrictions(
      contract_id,
      contract_access_restrictions
    ) {
      const clientId = this.$route.params.id;

      contract_access_restrictions.forEach((contract_access_restriction) => {
        deleteDomainOrEmailQry(
          clientId,
          contract_id,
          contract_access_restriction.id
        );
      });
    },
  },
};
</script>

<style scoped>
.contract-list-action > .ivu-btn:first-of-type {
  margin-right: 20px;
}

.ivu-table-title {
  margin-bottom: 186px !important;
}
</style>